"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AllianceOrderSwitchTransport = void 0;
const typebox_1 = require("@sinclair/typebox");
exports.AllianceOrderSwitchTransport = typebox_1.Type.Object({
    id: typebox_1.Type.String(),
    fromOrder: typebox_1.Type.String(),
    toOrder: typebox_1.Type.String(),
    type: typebox_1.Type.Optional(typebox_1.Type.String()),
});
//# sourceMappingURL=alliance-order-switch-transport.js.map